module.exports = __webpack_public_path__ + "img/banner-home-20230701.b8cc20ac.jpg";